import React from 'react';
import { Plane } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Separator } from '@/components/ui/separator';

const formatTime = (dateTimeString) => {
  if (!dateTimeString) return '-';
  const date = new Date(dateTimeString);
  return date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
};

const formatDate = (dateTimeString) => {
  if (!dateTimeString) return '-';
  const date = new Date(dateTimeString);
  return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};

const FlightSegmentCard = ({ segment }) => {
  const flightNumber = `${segment.carrier}${segment.flight_no}`;

  return (
    <div className="flex items-center gap-3 py-2">
      {/* Flight number */}
      <span className="text-sm font-medium text-slate-900 w-16">{flightNumber}</span>

      {/* Route: DEP → ARR */}
      <div className="flex items-center gap-1.5">
        <span className="font-semibold text-slate-900">{segment.dep_iata}</span>
        <Plane className="h-3 w-3 text-slate-400" />
        <span className="font-semibold text-slate-900">{segment.arr_iata}</span>
      </div>

      {/* Date & Time */}
      <span className="text-sm text-slate-500">
        {formatDate(segment.dep_dt)} · {formatTime(segment.dep_dt)}
      </span>

      {/* Booking class */}
      {segment.booking_class && (
        <Badge variant="secondary" className="text-xs">{segment.booking_class}</Badge>
      )}
    </div>
  );
};

const FlightSegmentsSection = ({ segments }) => {
  const originalSegments = segments.filter(s => s.segment_type === 'original' || !s.segment_type);
  const actualSegments = segments.filter(s => s.segment_type === 'actual');

  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <Plane className="h-5 w-5 text-cyan-500" />
        <h5 className="font-semibold">Flight Segments</h5>
        <Badge variant="info" className="text-xs">{segments.length}</Badge>
      </div>

      {segments.length === 0 ? (
        <p className="text-slate-500 text-sm text-center py-4">No flight segments yet</p>
      ) : (
        <div className="space-y-4">
          {originalSegments.length > 0 && (
            <div>
              <p className="text-xs font-medium text-slate-500 uppercase tracking-wide mb-2">Original Booking</p>
              <div className="divide-y divide-slate-100">
                {originalSegments.map((segment, index) => (
                  <FlightSegmentCard key={segment.id || `orig-${index}`} segment={segment} />
                ))}
              </div>
            </div>
          )}

          {actualSegments.length > 0 && (
            <>
              <Separator />
              <div>
                <p className="text-xs font-medium text-slate-500 uppercase tracking-wide mb-2">Actual Route</p>
                <div className="divide-y divide-slate-100">
                  {actualSegments.map((segment, index) => (
                    <FlightSegmentCard key={segment.id || `actual-${index}`} segment={segment} />
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default FlightSegmentsSection;
